import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1, H2, B1 } from '../../StyledComponents';
import { navigate } from '@reach/router';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import EnhancedBadge from '../../../assets/v2/Hardware/badge-enhanced.svg';
import CustomHardware from '../../../assets/v2/png/CustomHardware.png';
const Section = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  padding-bottom: 3rem;
  background-color: #f9f9fb;
`;
const SecondSection = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  padding-bottom: 3rem;
  background-color: #ffffff;
`;

const ManageHeading = styled.div`
  text-align: center;
  color: #7a55a5;
  margin-top: 5rem;
  @media (max-width: 520px) {
    margin-top: 1rem;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  padding-top: 2rem;
  grid-gap: 2rem;
  padding-bottom: 3rem;
  /* flex-wrap: wrap; */
  width: 50%;
  margin-right: -3rem;
  margin-left: -3rem;
  justify-content: center;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(1, 1fr);
    width: 75%;
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    padding-top: 0rem;
    margin-top: -1rem;
    padding-bottom: 2rem;
  }
`;

const HoveringLayer = styled.div`
  grid-column: span 1;
  min-width: 250px;
  /* flex: 0 0 calc(25%); */
  margin-top: 2rem;
  background: #725cbd;
  width: 100%;
  position: absolute;
  top: -2rem;
  z-index: 10;
  display: grid;
  cursor: pointer;
  height: 100%;
  opacity: 0.95;
  box-shadow: 0 1px 4px 0 rgba(66, 56, 128, 0.3);
  border-radius: 4px;
  @media (max-width: 768px) {
    padding-top: 4rem;
    flex: 0 0 calc(100%);
    padding-right: 10%;
    padding-left: 10%;
    display: grid;
    justify-items: center;
  }
  @media (max-width: 400px) {
    min-width: unset;
  }
`;

const HoveringLayerValidated = styled(HoveringLayer)`
  background: #7ec79c;
`;
const HoveringContent = styled.div`
  display: grid;
  justify-content: center;
  padding: 4rem;
  align-content: center;
  @media (max-width: 520px) {
    padding: 2rem;
  }
`;

const HoveringPoint = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  color: #ffffff;
  padding-bottom: 0.5rem;
`;
const GridItem = styled.div`
  grid-column: span 1;
  min-width: 10rem;
  justify-self: center;
  /* flex: 0 0 calc(25%); */
  margin-top: 2rem;
  transition: transform 0.3s ease-in;
  width: 50%;
  :hover {
    transform: scale(1.05);
    opacity: 0.8;
  }
  margin-right: 0.5rem;
  position: relative;
  background: white;
  box-shadow: 0 1px 4px 0 rgba(66, 56, 128, 0.3);
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  @media (max-width: 768px) {
    flex: 0 0 calc(100%);
    /* display: grid; */
    width: 100%;
    justify-items: center;
  }
  @media (max-width: 520px) {
    margin-left: 0.5rem;
  }
  @media (max-width: 400px) {
    min-width: unset;
    width: 100%;
    margin-left: 0;
  }
`;

const imageStyle = {
  maxWidth: '100%',
  maxHeight: '100%',
  alignSelf: 'center',
};

const ImgContainer = styled.div`
  display: grid;
  justify-items: center;
  height: 20rem;
  padding: 2rem 1rem;
  @media (max-width: 520px) {
    padding: 1rem;
    height: 18rem;
  }
`;

const GridTop = styled.div`
  min-height: 3rem;
`;

const GridBottom = styled.div`
  min-height: 3rem;
  background: #f4f4f4;
  padding: 1rem;
  width: 100%;
`;

const GridBottomText = styled(H2)`
  text-align: center;

  color: #000f16;
`;
const imageStyleTop = {
  width: '100%',
};

const ImgContainerTop = styled.div`
  display: grid;
  width: 100%;
  justify-content: end;
  grid-column: span 1;
  right: 0;
`;
export default class extends React.Component {
  state = {
    hover: -1,
  };
  handleHover = (index: number) => {
    this.setState({
      hover: index,
    });
  };
  handleHoverExit = () => {
    this.setState({
      hover: -1,
    });
  };

  render() {
    return (
      <div>
        <Section id="enhanced-devices">
          <ManageHeading>
            <H1 style={{ color: '#000f16' }}>Developer Kits</H1>
          </ManageHeading>
          <GridContainer>
            <GridItem
              onMouseEnter={() => this.handleHover(1)}
              onMouseLeave={this.handleHoverExit}
              onClick={() => navigate(`/SB30-EVK`)}
            >
              {this.state.hover === 1 && (
                <HoveringLayer>
                  <HoveringContent>
                    <HoveringPoint>Anrdoid 9.0 </HoveringPoint>
                    <HoveringPoint>Flexible</HoveringPoint>
                    <HoveringPoint>Economical</HoveringPoint>
                    <HoveringPoint>Performance</HoveringPoint>
                  </HoveringContent>
                </HoveringLayer>
              )}
              <GridTop>
                <ImgContainerTop>
                  <LazyLoadImage
                    alt={'Esper Enhanced'}
                    src={EnhancedBadge}
                    style={imageStyleTop}
                  />
                </ImgContainerTop>
              </GridTop>
              <ImgContainer>
                <LazyLoadImage
                  alt={`item.node.title`}
                  src={CustomHardware}
                  style={imageStyle}
                />
              </ImgContainer>
              <GridBottom>
                <GridBottomText>SB30 EVK </GridBottomText>
              </GridBottom>
            </GridItem>
          </GridContainer>
        </Section>
      </div>
    );
  }
}
